import { apiAction } from 'apa/actions'
import * as types from 'customers/actions/types'


export const add = (timeSheet) => (dispatch, getState) =>
  dispatch(apiAction({
    url: 'https://apabackend.quixtest.de/api/time_sheets/',
    method: 'POST',
    data: timeSheet,
    onSuccess: (timeSheet) => {
      const customer = getState().customers.customer
      customer.time_sheets.push(timeSheet)
      return {
        type: types.ADD_TIME_SHEET,
        customer: customer
      }
    }
  }))

export const remove = (timeSheet) => (dispatch, getState) =>
  dispatch(apiAction({
    url: `https://apabackend.quixtest.de/api/time_sheets/${timeSheet.id}/`,
    method: 'DELETE',
    onSuccess: () => {
      const customer = getState().customers.customer
      const hourIndex = customer.time_sheets.findIndex(
        item => item.id === timeSheet.id
      )
      customer.time_sheets.splice(hourIndex, 1)
      return {
        type: types.DELETE_TIME_SHEET,
        customer: customer
      }
    }
  }))